import React, { PureComponent, useState, Fragment } from 'react';
import { withRouter, Link } from "react-router-dom";

import {
  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container,
} from 'reactstrap';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

import Gallery from './../Gallery';
import FloorPlans from './../FloorPlans';

import ExportComponentButton from '../../../../shared/components/buttons/ExportComponentButton';
import { Publisher } from '../../../../shared/pubsub/publisher.js';


import classnames from 'classnames';
import { _hasPermission	} from "../../../../shared/helpers/access";
import{
	_capitalizeText,
	_formatNumber,
	_slugifyText,
	_getBuildingURL
} from '../../../../shared/helpers/utils';

const useStyles = makeStyles((theme) => ({
  root: {
	display: 'flex',
	flexDirection: 'column',
	marginLeft:"-8px",
	alignItems: 'left',
	'& > *': {
	  margin: theme.spacing(1),      
	},
	
  },
  button:{
	'&.selected' :{
		background:"#D1D6E0"
	}
  }
}));

const Plans = (props) => {
	const [activeTab, setActiveTab] = useState(props.match && props.match.params.subtab ? props.match.params.subtab : 'floor-plans');
	
	const [period, setPeriod] = useState("all-time");
	
	const { unitsRes, buildingRes, statsRes, user } = props;  
	const _boro = buildingRes.borough;
	const _hood = buildingRes.neighborhood[0];
	const buildingNameOrAdr = buildingRes.name 
	  ? _capitalizeText(buildingRes.name)
	  : buildingRes.display_full_street_address
		? _capitalizeText(buildingRes.display_full_street_address)
		: _capitalizeText(buildingRes.full_street_address);
	const adr = buildingRes.display_full_street_address ? buildingRes.display_full_street_address : buildingRes.full_street_address;
	const summaryTitle = 'Building Plans - ' + buildingNameOrAdr + ', ' + _hood + ', ' + _boro;
	const _toggleTab = (tab) => {
		if (activeTab !== tab) {
		  const buildingURL = _getBuildingURL(buildingRes, 'building_slugs') + (tab ? `/tab/layout/${tab}` : '');
		  //props.history.replace(buildingURL);
		  window.history && window.history.pushState({}, null, buildingURL);
		  setActiveTab(tab)
		  Publisher.publish(`track.buildingPlansView.${tab}`, {building: buildingRes.key});
		}
	  };
	
	const classes = useStyles();
	
	return(
		<div>
		<Container className="dashboard" style={{ "border" : "0px solid #DBE0E8" }}>
			<div className="tabs"> 	
			<div className="tabs__wrap mb-2">
				<Nav tabs>
				   
				   <NavItem>
					<NavLink
					  className={classnames({ active: activeTab === 'floor-plans' })}
					  onClick={() => {
						_toggleTab('floor-plans');
					  }}
					>
					  <span className="tab-title">Floor Plans</span>
					</NavLink>
				  </NavItem>
				  {buildingRes.offering_floorplans &&
				  <NavItem>
					<NavLink
					  className={classnames({ active: activeTab === 'diagrams' })}
					  onClick={() => {
						_toggleTab('diagrams');
					  }}
					>
					  <span className="tab-title">Building Diagrams</span>
					</NavLink>
				  </NavItem>
			  	}
				 
				</Nav>
			  </div>
			</div>

		{activeTab === 'floor-plans' &&
		  <TabPane tabId="floor-plans">
			  <FloorPlans {...props} activeTab={activeTab} />
		  </TabPane>
		  }
		{activeTab === 'diagrams' &&
		  <TabPane tabId="diagrams">
			  <Gallery {...props} activeTab={activeTab} />
		  </TabPane>
		  }
		
		
			  
		</Container>	  
		</div>
		
	)
};

export default connect(state => ({
  user: state.user,
}))(withRouter(Plans));